import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

import { Box } from "../Grid";

const MagazineBlockItemDescription = styled(Box)`
  max-height: 4.8em;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media screen and (max-width: ${themeGet("breakpoints.md")}) {
    -webkit-line-clamp: 5;
    max-height: 6em;
  }
  @media screen and (max-width: ${themeGet("breakpoints.sm")}) {
    -webkit-line-clamp: none;
    height: auto;
  }
`;

MagazineBlockItemDescription.defaultProps = {
  lineHeight: 1,
  color: "bodyText",
};

export { MagazineBlockItemDescription };
